import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

export const StakeholderFilterModel = new Record({
    approved: undefined,
    dimension: "",
    full_name: "",
    topic: "",
    type: ""
})

const tagFields = ["topic", "dimension"]

export const updateStakeholderSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
